/** @format */

import { useQuery } from "@tanstack/react-query";
import ApiService from "../services/ApiService";

const createQuery = ({ queryKey, url }) => {
  return ({ select, enabled, params, query } = {}) => {
    const _queryKey = generateQueryKey({ queryKey, query, params });
    const requestUrl = generateUrl({ url, params });
    const newParams = generateParamsData({ query });

    return useQuery({
      select,
      queryFn: async ({ signal }) => {
        const { data } = await ApiService.fetchData({
          url: requestUrl,
          signal,
          params: newParams,
        });
        return data;
      },
      queryKey: _queryKey,
      enabled,
    });
  };
};

const generateQueryKey = ({ queryKey, query, params }) => {
  return typeof queryKey === "function"
    ? queryKey(query ?? {}, params ?? {})
    : queryKey;
};

const generateParamsData = ({ query }) => {
  return query ? query : {};
};

const generateUrl = ({ url, params }) => {
  if (!params) params = {};
  return typeof url === "function" ? url(params) : url;
};

export default createQuery;
